module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/grouping/grouping.component.css
// module id = ./src/app/examples/grouping/grouping.component.css
// module chunks = main